import { Component, Input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';

@Component({
    selector: 'uni-nav-card',
    template: `
    <p-card uni-card [header]="navItem.label">
      <i [class]="navItem.icon" class="mr-3" ></i>
      <ng-container *ngIf="navItem.routerLink">
        <a *ngIf="navItem.routerLink" [routerLink]="navItem.routerLink" class="p-button p-button-raised">
          Click for more
        </a>
      </ng-container>
      <ng-container *ngIf="onClick">
        <button *ngIf="onClick" (click)="onClick()" class="p-button p-button-raised">
          Click for more
        </button>
      </ng-container>
    </p-card>
      `,
    standalone: false
})
export class UniNavCardComponent implements OnInit {
  @Input() navItem: MenuItem;
  @Input() onClick: () => void;

  constructor() {

  }

  ngOnInit() {
    if (this.navItem == null) {
       this.navItem = { label: ' [Not found]', routerLink: ['/home'], icon: 'pi pi-home' };
    }

  }



}
